<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface InputGroupInputProps {
  class?: HTMLAttributes['class']
  disabled?: boolean
}
</script>

<script setup lang="ts">
import { computed, inject } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { INPUT_GROUP_KEY } from './InputGroup.vue'

const props = defineProps<InputGroupInputProps>()

const modelValue = defineModel<string | number | null>()

const group = inject(INPUT_GROUP_KEY, null)

const isDisabled = computed(() => props.disabled || group?.disabled.value || false)
const isInvalid = computed(() => group?.error.value ?? false)
</script>

<template>
  <input
    v-model="modelValue"
    :disabled="isDisabled || undefined"
    :aria-invalid="isInvalid || undefined"
    :class="
      cn(
        'h-full w-full min-w-0 grow bg-transparent p-0',
        'border-0 ring-0 outline-0 focus-visible:outline-hidden',
        'placeholder:text-placeholder disabled:cursor-not-allowed',
        props.class,
      )
    "
  />
</template>
